<script>
import Layout from '@layouts/main'
import HeaderPage from '@/src/components/register/header-page.vue'
import UsuarioForm from '@/src/components/forms/usuario-form.vue'
import Table from '@/src/components/tables/table-register.vue'

import UserService from '@/src/services/user'
import alertMixin from '@/src/mixins/alertMixin'
import usuarioMixin from '@/src/mixins/usuarioMixin'

export default {
  components: {
    Layout,
    HeaderPage,
    UsuarioForm,
    Table,
  },
  mixins: [alertMixin, usuarioMixin],
  data() {
    return {
      pageTitles: {
        title: 'Usuários',
        subtitle: 'Gerenciamento de usuários aqui.',
      },
      usuario: {},
      usuarios: [],
      formOpen: true,
      isLoading: false,
      userType: this.$store.state.auth.currentUser.type,
      token: this.$store.state.auth.access_token,
      filter: '',
    }
  },
  computed: {},
  watch: {
    filter() {
      this.onFilter()
    },
  },
  async created() {
    await this.listando()
  },

  methods: {
    isEmailUsed() {
      UserService.usedValue('email', this.usuario.email)
        .then((response) => {
          this.usado.email = response
          if (response) {
            this.$bvToast.toast(
              'Este email já está sendo usado. Por favor, tente outro.',
              {
                variant: 'alert-danger',
                autoHideDelay: 5000,
                solid: false,
                noCloseButton: true,
                toaster: 'b-toaster-top-center',
              }
            )
          }
        })
        .catch((error) => {
          this.usado.email = false
          this.serviceCatchHandler(error)
        })
    },

    async listando() {
      try {
        this.isLoading = true
        let res = await this.loadUsuarios(this.filter)
        this.usuarios = res
        this.isLoading = false
      } catch (error) {
        this.errorMessage(error)
        this.isLoading = false
      }
    },

    abrirForm() {
      if (this.formOpen === true) {
        this.formOpen = false
        this.isEdit = false
      } else {
        this.formOpen = true
        this.formsubmit = false
        this.usuario = {}
      }
    },

    handleDelete(value) {
      this.patientId = value
      UserService.remove(this.patientId)
        .then((resposta) => {
          this.$bvToast.toast(resposta.data.message, {
            variant: 'success',
            solid: false,
            noCloseButton: true,
            toaster: 'b-toaster-top-center',
          })
          this.listando()
        })
        .catch((err) => {
          this.isLoading = this.loading(this.isLoading)
          this.$bvToast.toast(
            'Ocorreu um erro ao deletar, verifique se o item está sendo utilizado em outro lugar.',
            {
              variant: 'danger',
              solid: false,
              noCloseButton: true,
              toaster: 'b-toaster-top-center',
            }
          )
        })
      this.patientId = null
      this.modal = false
    },
    onSubmit(user) {
      this.usuario = user
      this.isLoading = true

      UserService.create(this.usuario).then((response) => {
        this.$bvToast.toast(response.data.message, {
          title: 'Aviso',
          variant: 'success',
          solid: true,
        })

        this.usuario = {}
        this.abrirForm()
        this.listando()
      })
      .catch((error) => {
        this.errorMessage(`Ocorreu um erro ao tentar salvar o usuário: ${error.response.data.message}`)
      })
      .finally(() => {
        this.isLoading = false
      })
    },

    async onEdit(user) {
      try {
        this.isLoading = true
        const response = await UserService.update(user._id, user)
        this.successMessage('Usuário Atualizado')
        this.isEdit = false
        this.abrirForm()
        this.listando()
        this.isLoading = false
      } catch (error) {}
    },

    modalEdit(item) {
      this.usuario = item
      this.formOpen = false
      this.isEdit = true
    },

    handleSalveOrEdit(user) {
      if (user._id) {
        this.onEdit(user)
      } else {
        this.onSubmit(user)
      }
    },

    invalidForm() {
      this.$bvToast.toast('Há campos que não foram preenchidos', {
        variant: 'danger',
        solid: false,
        noCloseButton: true,
        toaster: 'b-toaster-top-center',
      })
      this.formsubmit = true
    },

    validForm() {
      this.$v.$touch()
      !this.$v.usuario.$error && !this.usado.email
        ? this.isEdit
          ? this.onEdit()
          : this.onSubmit()
        : this.invalidForm()
    },
  },
}
</script>
<template>
  <Layout :is-loading="isLoading">
    <div class="bloco">
      <HeaderPage
        :form-open="formOpen"
        :page-titles="pageTitles"
        @onClick="abrirForm"
      />
      <div class="col-md-8 d-flex">
        <b-form-group id="input-group-1" class="col-8" label="Pesquisar" label-for="filter">
          <b-input-group>
            <b-form-input
              id="filter"
              v-model="filter"
              type="text"
              placeholder="Pesquisar..."
            ></b-form-input>
            <b-input-group-append>
              <b-button @click="listando"
                >Pesquisar</b-button
              >
            </b-input-group-append>
          </b-input-group>
        </b-form-group>
      </div>
      <div>
        <div v-if="formOpen">
          <Table
            :formOpen="formOpen"
            :tablesFields="usuariosFields"
            :tableItems="usuarios"
            @onEdit="modalEdit($event)"
            @onDelete="handleDelete($event)"
          />
        </div>
        <div v-else>
          <UsuarioForm :usuario="usuario" :salvar="onSubmit" :editar="onEdit" />
        </div>
      </div>
      <div class="borda"></div>
    </div>
  </Layout>
</template>
<style src="../style.scss" lang="scss"></style>
